<span
  class="app-icon__content"
  [ngClass]="iconClass()"
  [style.width]="sizeValue()"
  [style.height]="sizeValue()"
  [style.font-size]="sizeValue()"
  [attr.role]="ariaLabel() ? 'img' : null"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-hidden]="ariaHidden()"
>
  @if (svgMarkup(); as svg) {
    <span class="app-icon__svg" [innerHTML]="svg | safeHtml"></span>
  }
</span>
